export default __webpack_public_path__ + "static/covid-id-1b1bfed23718afe6a6bfbeb813237d72.jpg";